// extracted by mini-css-extract-plugin
export default {"inactive":"UserRow_inactive__s-iWR"};